export const measurementTypes = [
	'lineal', // added to libs/shared/constants/src/constants/report/Volumetrics.ts
	'square', // added to libs/shared/constants/src/constants/report/Volumetrics.ts
	'cubic', // added to libs/shared/constants/src/constants/report/Volumetrics.ts
	'count', // added to libs/shared/constants/src/constants/report/Volumetrics.ts
	'currency', // added to libs/shared/constants/src/constants/report/Volumetrics.ts
] as const;
